// @flow

import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { spacing, fontSize } from 'frontend_core/dist/styles/variables'
import { imagePath } from 'frontend_core/dist/helpers/image'
import ModalSelect from 'components/organisms/ModalSelect'
import OptimizedImage from 'components/atoms/OptimizedImage'

const ThumbnailContainer = styled.div`
  position: relative;
  margin: ${spacing.large}px auto 0;
  width: 100%;
  max-width: 250px;
`

const ThumbnailWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 60%;
  border: 1px solid ${Colors.grayD};
`

const Thumbnail = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: ${Colors.white};
  ${({ imageUrl }) => `
    background-image: url('${imageUrl}');
  `}
  background-color: ${Colors.grayF};
  background-size: 45px;
  background-repeat: no-repeat;
  background-position: center;
`

const ThumbnailTitle = styled.p`
  margin-top: ${spacing.medium}px;
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
  text-align: center;
`

type PropTypes = {
  isActive: boolean,
  onClickClose: Function,
  src: string,
  isAttachment?: boolean,
  filename: string,
  onClickPositive?: Function,
  onClickNegative: Function,
}

export default (props: PropTypes) => {
  const confirmContent = {
    isActive: props.isActive,
    onClickClose: props.onClickClose,
    title: i18n.t('page.dashboard.reservation.sendFile'),
    textList: [i18n.t('page.dashboard.reservation.sendFileConfirm')],
    negativeButton: {
      text: i18n.t('page.shared.cancel'),
      onClick: props.onClickNegative,
    },
    positiveButton: {
      text: i18n.t('page.shared.send'),
      onClick: props.onClickPositive,
    },
  }

  return (
    <ModalSelect {...confirmContent}>
      <ThumbnailContainer>
        {props.isAttachment ? (
          <ThumbnailWrapper>
            <Thumbnail imageUrl={imagePath('common/file.svg')} />
          </ThumbnailWrapper>
        ) : (
          <OptimizedImage src={props.src} alt="" type="flex" />
        )}
      </ThumbnailContainer>
      <ThumbnailTitle>{props.filename}</ThumbnailTitle>
    </ModalSelect>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationConfirmSendAttachmentModal/index.jsx